import { Loader, NoBgLoaderWrapper } from '../page-loader/styled-components'

export const AsyncLoaderPage = () => (
  <NoBgLoaderWrapper className="noscroller">
    <Loader className="loader" />
  </NoBgLoaderWrapper>
)
